import {Mandate} from "@ferry/journey-services";

const ACTIVE_MANDATE_STATUSES = ["NEW", "REQUESTED", "VALID"];
const REFUND_MANDATE_TYPE = "REFUND";

export const getLatestActivePaymentMandate = (mandates?: Mandate[]): Mandate | undefined =>
    getLatestActiveMandate(mandates, (mandate: Mandate) => mandate.type !== REFUND_MANDATE_TYPE);

export const getLatestActiveRefundMandate = (mandates?: Mandate[]): Mandate | undefined =>
    getLatestActiveMandate(mandates, (mandate: Mandate) => mandate.type === REFUND_MANDATE_TYPE);

const getLatestActiveMandate = (
    mandates: Mandate[] | undefined,
    mandateTypeFilter: (mandate: Mandate) => boolean
): Mandate | undefined =>
    [...(mandates || [])]
        .filter((mandate: Mandate) => ACTIVE_MANDATE_STATUSES.includes(mandate.status) && mandateTypeFilter(mandate))
        .sort((firstMandate: Mandate, secondMandate: Mandate) => Number(secondMandate.id) - Number(firstMandate.id))[0];
